import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

const mapSpocRecord = (record) => ({
  id: record.userId ?? record.id,
  employeeId: record.userId,
  employeeName: record.employeeName || record.userName || "",
  email: record.email || "",
  mobileNumber: record.mobileNumber || "",
  lob: record.lobType || record.lob || "",
  department: record.department || "",
  role: record.role || "",
  isActive: record.isActive !== false,
});

/**
 * Fetch SPOC list with pagination and optional search.
 * GET api/SpocCreation/spoc-list?pageNumber=1&pageSize=10[&searchValue=...]
 */
export const fetchSpocListAction = async ({
  searchValue = "",
  pageNumber = 1,
  pageSize = 10,
} = {}) => {
  try {
    const params = new URLSearchParams();
    params.set("pageNumber", String(pageNumber));
    params.set("pageSize", String(pageSize));

    const trimmedSearch = searchValue?.trim();
    if (trimmedSearch) {
      params.set("searchValue", trimmedSearch);
    }

    const response = await apiClient.get(
      `${ATP_API_URL.SPOC_LIST}?${params.toString()}`,
    );

    if (response?.status === 200 && response.data) {
      const rawList = Array.isArray(response.data)
        ? response.data
        : response.data?.data ||
          response.data?.spocList ||
          response.data?.result ||
          [];

      const totalRecords =
        response.data?.totalRecords ??
        response.data?.totalCount ??
        response.data?.pagination?.totalItems ??
        rawList.length;

      return {
        success: true,
        data: rawList.map(mapSpocRecord),
        totalRecords,
        pageNumber: response.data?.pageNumber ?? pageNumber,
      };
    }

    return {
      success: false,
      message: "Failed to fetch SPOC list",
      data: [],
      totalRecords: 0,
    };
  } catch (error) {
    return {
      success: false,
      message: error.message || "Failed to fetch SPOC list",
      data: [],
      totalRecords: 0,
    };
  }
};
